<template>
  <div @click="closeMultiSelect">
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">Invite Teacher</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- ERROR ALERT -->
        <div style="position: relative; top: -30px; margin-bottom: -8px">
          <AuthAlertCard
            v-if="show_alert"
            :alert_type="alert_type"
            :alert_msg="alert_msg"
          ></AuthAlertCard>
        </div>

        <form action @submit.prevent="sendInvitation" autocomplete="off">
          <!-- TEACHER NAME -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label for="teacherName" class="control-label label-compact"
                >Name</label
              >
              <input
                type="text"
                v-model="form.receiver_name"
                class="form-control"
                id="teacherName"
                required
                placeholder="The name of the teacher"
              />
            </div>
          </div>

          <!-- TEACHER EMAIL ADDRESS -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label for="teacherEmail" class="control-label label-compact"
                >Email Address</label
              >
              <input
                type="email"
                v-model="form.receiver_email"
                class="form-control"
                id="teacherEmail"
                required
                placeholder="Teacher’s email Address"
              />
            </div>
          </div>

          <!-- TEACHER PHONE NUMBER -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label for="teacherPhone" class="control-label label-compact"
                >Phone Number</label
              >
              <input
                type="number"
                v-model="form.receiver_phone"
                class="form-control"
                id="teacherPhone"
                required
                placeholder="The phone number of the Teacher"
              />
            </div>
          </div>

          <!-- TEACHER CLASS -->
          <div class="ignore" style="margin-bottom: 35px">
            <Multiselect
              label_text="Assign Class"
              :label_compact="true"
              :options="class_options"
              :trigger_close="close_select"
              :multiple="false"
              placeholder="Assign to a class"
              @selectionDone="updateCLassList($event)"
            ></Multiselect>
          </div>

          <!-- TEACHER SUBJECT -->
          <div class="ignore">
            <Multiselect
              label_text="Assign Subject(s)"
              :label_compact="true"
              :options="subject_options"
              :trigger_close="close_select"
              :multiple="true"
              placeholder="Assign subject(s)"
              @selectionDone="updateSubjectList($event)"
            ></Multiselect>
          </div>

          <!-- SEND INVITATION-->
          <div class="modal-body-row row mb-1">
            <div class="col-12 d-flex flex-center">
              <button
                type="submit"
                class="btn btn-md btn-accent"
                ref="invitationBtn"
              >
                Send Invitation
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";
import Multiselect from "@/components/globalComps/Multiselect";
import { setTimeout } from "timers";

export default {
  name: "AddTeacherModal",

  components: {
    Modal,
    Multiselect,
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */
        "@/components/globalComps/AuthComps/AuthAlertCard.vue"
      ),
  },

  data() {
    return {
      value: [],
      form: {
        receiver_name: "",
        receiver_email: "",
        receiver_phone: "",
        receiver_class: "",
        receiver_subjects: [],
      },
      class_options: [],
      subject_options: [],
      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null,
      close_select: true,
    };
  },

  mounted() {
    this.fetchClasses();
    this.fetchSubjects();
  },

  computed: {
    ...mapGetters(["getTour", "startTour"]),
  },

  methods: {
    ...mapActions([
      "nextTour",
      "inviteSchoolTeacher",
      "getSchoolClasses",
      "getSubjectList",
    ]),

    closeMultiSelect($event) {
      if ($event.target.classList.contains("ignore")) return false;
      else this.close_select = !this.close_select;
    },

    fetchClasses() {
      this.getSchoolClasses()
        .then((response) => {
          response.data.map((year) => {
            year.classes.map((arm) => {
              let class_arm = {};
              class_arm.id = arm.id;
              class_arm.name = `${arm.class_name}`;
              class_arm.selected = false;
              this.class_options.push(class_arm);
            });
          });
        })
        .catch((err) => console.log(err));
    },

    fetchSubjects() {
      this.getSubjectList()
        .then((response) => {
          if (response.data.length > 0) {
            response.data.map((subject) => {
              let subject_data = {};

              subject_data.id = subject.subject_id;
              subject_data.name = subject.name;
              subject_data.selected = false;

              this.subject_options.push(subject_data);
            });
          } else {
            this.subject_options.push({});
          }
        })
        .catch((err) => console.log(err));
    },

    updateCLassList($event) {
      let { selection } = $event;
      if (selection.length > 0)
        this.form.receiver_class = Number(selection[0].id);
      else this.form.receiver_class = "";
    },

    updateSubjectList($event) {
      let { selection } = $event;
      this.form.receiver_subjects = [];
      if (selection.length > 0)
        selection.map((subject) => {
          this.form.receiver_subjects.push(Number(subject.id));
        });
      else this.form.receiver_subjects = []; 
    },

    sendInvitation() {
      this.$refs.invitationBtn.disabled = true;
      this.$refs.invitationBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      this.inviteSchoolTeacher(this.form)
        .then((response) => {
          if (response.code === 200) {
            setTimeout(() => {
              this.show_alert = false;

              this.$refs.invitationBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2"></div>Successful';
            }, 1000);

            if (this.startTour && this.getTour.current_number == 3) {
              //check condition
              this.nextTour(4);
            }

            setTimeout(() => {
              let dialog_data = {
                msg: "Teacher invitation was sent successfully",
                type: "success",
              };
              this.$emit("showAlertCard", dialog_data);
              this.$emit("closeTriggered");
            }, 3000);
          }
          // HANDLE NON 200 RESPONSE
          else {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";
              this.alert_msg = Object.values(response.data)[0].toString();

              this.$refs.invitationBtn.innerText = "Send Invitaion";
              this.$refs.invitationBtn.disabled = false;
            }, 1000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style></style>
